import $ from 'jquery';
import Swiper, { Navigation, Scrollbar } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Scrollbar]);

'use strict';

$( '.cff' ).addClass( 'swiper-container' );
$( '.cff-posts-wrap' ).addClass( 'swiper-wrapper' );
$( '.cff-item' ).addClass( 'swiper-slide' );

var imageLinks = [];
var videoLinks = [];

var photos = document.querySelectorAll( '.cff-media-wrap .cff-photo' );
photos = [].slice.call( photos );
photos.forEach( function ( link ) {
	imageLinks.push( link.href );
} );

var videoplayButtons = document.querySelectorAll( '.cff-html5-video .cff-html5-play' );
videoplayButtons = [].slice.call( videoplayButtons );
videoplayButtons.forEach( function ( link ) {
	videoLinks.push( link.href );
} );

var mediawraps = document.querySelectorAll( '.cff-media-wrap' );
mediawraps = [].slice.call( mediawraps );
mediawraps.forEach( function ( item ) {
	var button = '<span class="cff-button">Bekijk de post op facebook</span>';
	$( item ).next().append( button );
} );

var videos = document.querySelectorAll( '.cff-html5-video' );
videos = [].slice.call( videos );
videos.forEach( function ( item ) {
	var button = '<span class="cff-button">Bekijk de post op facebook</span>';
	$( item ).next().append( button );
} );


var facebookSwiper;
facebookSwiper = new Swiper( '.cff', {
	loop: false,
	spaceBetween: 16,
	slidesPerView: 2.2,
	slidesPerGroup: 1,
	breakpoints: {
		480: {
			slidesPerView: 3.2,
		},
		640: {
			slidesPerView: 3.5,
		},
		1024: {
			slidesPerView: 4.3,
		}
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true,
		dragSize: 150,
	},
} );

